import { registerLocaleData } from "@angular/common";
import localeKo from "@angular/common/locales/ko";
import {
    ApplicationConfig,
    importProvidersFrom,
    LOCALE_ID,
    provideZonelessChangeDetection,
} from "@angular/core";
import {
    BrowserModule,
    provideClientHydration,
    withHttpTransferCacheOptions,
} from "@angular/platform-browser";
import {
    provideRouter,
    withComponentInputBinding,
    withViewTransitions,
} from "@angular/router";

import {
    provideHttpClient,
    withFetch,
    withInterceptors,
} from "@angular/common/http";
import { ApiModule } from "@malirang/api-client";
import { provideComponentConfig } from "@malirang/front-share";
import { provideMarkdown } from "ngx-markdown";
import { environment } from "../env/env";
import { HttpInterceptor } from "../libs/http-interceptor";
import { appRoutes } from "./app.routes";

registerLocaleData(localeKo);

export const appConfig: ApplicationConfig = {
    providers: [
        provideClientHydration(
            withHttpTransferCacheOptions({
                includePostRequests: false,
                filter: (req) => false,
            }),
        ),
        provideRouter(
            appRoutes,
            withViewTransitions(),
            withComponentInputBinding(),
        ),
        provideZonelessChangeDetection(),
        importProvidersFrom(
            BrowserModule,
            ApiModule.forRoot({
                rootUrl: environment.baseUrl,
            }),
        ),
        provideMarkdown(),
        { provide: LOCALE_ID, useValue: "ko" },
        provideHttpClient(withFetch(), withInterceptors([HttpInterceptor])),

        provideComponentConfig({
            button: {
                rounded: "xl",
            },
            badge: {
                rounded: "lg",
                size: "sm",
            },
            input: {
                rounded: "xl",
                size: "sm",
            },
            label: {},
        }),
    ],
};
